export class UserStats {
    totalCourses = 0;
    finishedCourses = 0;
    hoursOfStudy = 0;
    streak = 0;
    certificates = 0;

    constructor() {
        this.finishedCourses = 12;
        this.hoursOfStudy = 145;
        this.streak = 7;
        this.certificates = 8;
    }
}
